module.exports = __webpack_public_path__ + "static/media/ic_bookmark.229ed409.svg";